unit NetNumberStatusType;
{

/* property RemarksOR added. */

}
interface

uses
  DeviceType, NetNumberType, NetStatusType, UserType, TemperatureType;

type
  TNetNumberStatusType = class
  private
    fNetNumberStatusKey: String;
    fNetNumber: TNetNumberType;
    fNetStatus: TNetStatusType;
    fDevice: TDeviceType;
    fTemperature: TTemperatureType;
    fCharge: String;
    fStatusDate: String;
    fStatusTime: String;
    fStatusBy: TUserType;
    fRemarksOR: String;
  public
    property NetNumberStatusKey: String read fNetNumberStatusKey;
    property NetNumber: TNetNumberType read fNetNumber;
    property NetStatus: TNetStatusType read fNetStatus;
    property Device: TDeviceType read fDevice;
    property Temperature: TTemperatureType read fTemperature;
    property Charge: String read fCharge;
    property StatusDate: String read fStatusDate;
    property StatusTime: String read fStatusTime;
    property StatusBy: TUserType read fStatusBy;
    property RemarksOR: String read fRemarksOR;
  end;

implementation

end.
